import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import PageTitle from "../../../components/Common/PageTitle";
import LinkBox from "../../../components/Content/LinkBox";

const NLP = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PageTitle
        title={"NLP Training"}
        text={
          "The Institute of Interpersonal Hypnotherapy offers comprehensive Basic and Master Training in Neuro-Linguistic Programming (NLP), led by Master NLP Instructor Luis Miguel Gallardo. These live, practical courses consist of 65 hours each for both Basic and Master levels. The training includes two three-day sessions (Friday through Sunday), with nine hours of instruction each day, complemented by three 2-hour orientation and practical supervision sessions for each training level."
        }
        icon={require("../../../assets/images/nlp.png")}
        videoUrl={
          "https://drive.google.com/file/d/123oCALxjftd4zJAfW9qhyoB6IiF2E9_J/preview"
        }
      />

      <Box sx={{ my: 1 }}>
        {/* <LinkBox
          title={"Institute of Hypnotherapy"}
          link={
            "https://www.instituteofhypnotherapy.com/course/interpersonal-nlp-basic-master-certification-training/?utm_source=chatgpt.com"
          }
        /> */}

        <Typography sx={[theme.body, { mt: 4 }]}>
          Luis Gallardo is the Founder and President of the World Happiness
          Foundation and World Happiness Fest, platforms that unite and amplify
          the impact of thousands of leaders in human development, happiness,
          and well-being worldwide. He is also a Certified Mental Health Coach
          and Master NLP Trainer.
        </Typography>

        <LinkBox
          title={"Institute of Hypnotherapy | Luis Gallardo"}
          link={"https://www.instituteofhypnotherapy.com/staff-credentials/"}
        />

        <Typography sx={[theme.body, { mt: 4 }]}>
          For more information on upcoming training dates and details on
          integrating NLP into your existing skill set, please visit the
          Institute's page below.
        </Typography>

        <LinkBox
          title={"Interpersonal NLP Basic & Master Certification Training"}
          link={
            "https://www.instituteofhypnotherapy.com/course/interpersonal-nlp-basic-master-certification-training/"
          }
        />
      </Box>
    </Box>
  );
};

export default NLP;
